import {Component, Inject, Input} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProjectInstallBidQuestion} from "../../core/models/project-install-bid-question.interface";

export interface QuestionDialogData {
  parentQuestionId: number;
}

@Component({
  selector: 'app-install-ask-question-dialog',
  templateUrl: './install-ask-question-dialog.component.html',
  styleUrls: ['./install-ask-question-dialog.component.scss']
})
export class InstallAskQuestionDialogComponent {

  busy: boolean = false;

  questionForm = new FormGroup({
    question: new FormControl('', [Validators.required ])
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: QuestionDialogData,
                private dialogRef: MatDialogRef<InstallAskQuestionDialogComponent>
  ) {
    dialogRef.disableClose = true;
  }

  submitQuestion() {
    let question: ProjectInstallBidQuestion = {};
    if(this.questionForm.controls.question.value) {
      question = {
        questionAsked: this.questionForm.controls.question.value
      }
    }
    if(this.data?.parentQuestionId) {
      question.parentQuestionId = this.data.parentQuestionId;
    }
    this.dialogRef.close(question);
  }
}
